/* eslint-disable react/no-danger */

import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import { default as sanitize } from 'sanitize-html';
import {
    DIGITAL_CONTENT_EMBED_PARAM,
    GA_ACTION_VIEW_LIVESTREAM_LINK,
    HTML_SANITIZER_CONFIG,
} from '../../constants';
import { getVimeoEmbedUrl } from '../../utils';
import { EmbedWithFallbackContent } from './EmbedWithFallbackContent';
import { Iframe } from './Iframe';
import { Timer } from './Timer';

export const VIMEO_PROVIDER = 'vimeo';
export const YOUTUBE_PROVIDER = 'youtube';

const isNotEmbedUrl = (url: string) => {
    if (!isEmpty(url)) {
        return url.indexOf(`${DIGITAL_CONTENT_EMBED_PARAM}=false`) !== -1;
    }
};

interface Props {
    data?: {
        image?: { url: string };
        chatUrl?: { url: string };
        instructions?: { text: string };
        livestreamProvider?: { text: string };
        livestreamUrl?: { text: string; url: string };
    };
    event?: { start: { utc: string }; end: { utc: string } };
    onClick: Function;
}

export const LivestreamModule: React.FC<Props> = ({ data, event, onClick }) => {
    const imageUrl = data?.image?.url || '';
    const chatUrl = data?.chatUrl?.url || '';
    const instructionsText = data?.instructions?.text || '';
    const livestreamUrl = data?.livestreamUrl?.url || '';
    const provider = data?.livestreamProvider?.text;
    const isVimeoLivestream =
        provider === VIMEO_PROVIDER && !isNotEmbedUrl(livestreamUrl);
    const [embedUrl, setEmbedUrl] = useState(livestreamUrl);

    useEffect(() => {
        if (isVimeoLivestream) {
            getVimeoEmbedUrl(livestreamUrl).then((url) => {
                setEmbedUrl(url);
            });
        }
    }, [livestreamUrl, isVimeoLivestream]);

    const action = onClick(event, GA_ACTION_VIEW_LIVESTREAM_LINK, embedUrl);

    const showTimerBubble = !(
        (provider === YOUTUBE_PROVIDER || provider === VIMEO_PROVIDER) &&
        !isNotEmbedUrl(embedUrl)
    );

    const __html = sanitize(instructionsText, HTML_SANITIZER_CONFIG);

    return (
        <div className="dc-modules__item--livestream">
            <h2 className="eds-l-mar-bot-4 eds-text-bl">
                {data?.livestreamUrl?.text}
            </h2>
            <div className="eds-l-mar-top-2 dc-modules__item--livestream__content">
                {!isEmpty(embedUrl) && (
                    <EmbedWithFallbackContent
                        url={embedUrl}
                        shouldEmbed={isVimeoLivestream}
                        imageUrl={imageUrl}
                        action={action}
                    />
                )}
                {showTimerBubble && (
                    <a
                        href={embedUrl}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <Timer
                            start={event?.start?.utc || ''}
                            end={event?.end?.utc || ''}
                        />
                    </a>
                )}
            </div>
            {chatUrl && (
                <div className="dc-iframe--vimeo-chat">
                    <Iframe url={chatUrl} />
                </div>
            )}
            <div
                data-spec="dc-modules__item--instructions"
                className="dc-modules__item--instructions"
                dangerouslySetInnerHTML={{ __html }}
            />
        </div>
    );
};
